import Swal from 'sweetalert2';
import $http from '../../../axios-instance';
import $http_cal from '../../../axios-instance-cal';
import {Notification} from 'element-ui';

/**
 * Obtener productos.
 */
export async function getProducts({state, commit}, restart_page = false) {

    if (restart_page) {
        commit('resetPageFilters');
    }

    commit('dashboard/load', true, {root: true});

    await $http_cal.get('products-calculator', {params: state.filters})
        .then((response) => {
            commit('setProducts', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener materias primas.
 */
export async function getRawMaterials({state, commit, rootState}, restart_page = false) {
    if (restart_page) {
        commit('resetPageParamsInModalRawMaterials');
    }

    commit('dashboard/load', true, {root: true});

    await $http_cal.get('products-calculator', {params: state.modal_raw_materials.params})
        .then((response) => {
            commit('setRawMaterials', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener producto.
 */
export async function getProductCompany({state, commit}, product) {
    commit('dashboard/load', true, {root: true});

    await $http_cal.get(`products-calculator-company/${product.id}/${product.slq_company_id}`)
        .then((response) => {
            commit('setDataToProduct', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener producto.
 */
export async function getProduct({state, commit}, {product_id, company_id}) {

    commit('dashboard/load', true, {root: true});

    await $http_cal.get(`products-calculator/${product_id}/${company_id}`)
        .then((response) => {
            commit('setProduct', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Petición para obtener fabricantes.
 */
export async function getManufacturersRequest({commit, rootState}, name) {
    return new Promise(async (resolve, reject) => {
        if (!rootState.dashboard.loading && name.length >= 3) {
            commit('dashboard/load', true, {root: true});

            await $http_cal.get('manufacturers', {params: {name}})
                .then((response) => {
                    commit('dashboard/load', false, {root: true});
                    resolve(response.data.data);
                })
                .catch((error) => {
                    console.log(error);
                    commit('dashboard/load', false, {root: true});
                    reject(error);
                });
        } else {
            reject();
        }
    });
}

/**
 * Obtener fabricantes.
 */
export async function getManufacturers({dispatch, commit}, name) {
    await dispatch('getManufacturersRequest', name)
        .then(data => commit('setManufacturers', data))
        .catch(error => console.log(error));
}

/**
 * Obtener fabricantes para filtros.
 */
export async function getManufacturersFilters({dispatch, commit}, name) {
    await dispatch('getManufacturersRequest', name)
        .then(data => commit('setManufacturersFilters', data))
        .catch(error => console.log(error));
}

/**
 * Crear producto.
 */
export async function createProduct({state, commit}) {

    commit('dashboard/load', true, {root: true});
    commit('setCompanyIdProduct');

    return new Promise(async (resolve, reject) => {
        await $http_cal.post('products-calculator', state.product)
            .then(async (response) => {
                commit('resetProduct');
                commit('setModalShow', false);
                commit('dashboard/load', false, {root: true});

                Notification.success({
                    title: 'Muy bien',
                    message: response.data.message,
                    type: 'success',
                    duration: 2000
                });

                resolve(response.data.data);
            })
            .catch((error) => {
                reject();
                console.log(error);
                commit('dashboard/load', false, {root: true});
            });
    });
}

/**
 * Actualizar producto.
 */
export async function updateProduct({state, commit}) {

    commit('dashboard/load', true, {root: true});
    commit('setCompanyIdProduct');

        await $http_cal.put(`products-calculator/${state.product.id}`, state.product)
            .then(async (response) => {
                commit('setProduct', response.data.data)
                commit('setModalShow', false);
                commit('dashboard/load', false, {root: true});

                Notification.success({
                    title: 'Muy bien',
                    message: response.data.message,
                    type: 'success',
                    duration: 2000
                });
            })
            .catch((error) => {
                console.log(error);
                commit('dashboard/load', false, {root: true});
            });
}

/**
 * Actualizar materia prima.
 */
export async function getRawMaterialTemp({state, commit, dispatch}, raw_material) {
    commit('dashboard/load', true, {root: true});

    await $http_cal.get(`raw-material-detail/${raw_material.id}`)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            commit('setRawMaterialTemp', response.data.data);
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Actualizar materia prima.
 */
export async function getRawMaterialCompany({state, commit, dispatch}, raw_material) {
    commit('dashboard/load', true, {root: true});

    await $http_cal.get(`raw-material-company/${raw_material.id}/${raw_material.slq_company_id}`)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            commit('setRawMaterial', response.data.data);
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});
        });
}


/**
 * Actualizar materia prima.
 */
export async function getRawMaterial({state, commit, dispatch}, raw_material) {

    commit('dashboard/load', true, {root: true});

    await $http_cal.get(`raw-material-detail/${raw_material.id}/${state.product.slq_company_id}`)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            commit('setRawMaterial', response.data.data);
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Crear materia prima.
 */
export async function createRawMaterial({state, commit, dispatch}) {

    commit('dashboard/load', true, {root: true});
    commit('setCompanyIdRawMaterial');

    await $http_cal.post(`products-calculator/${state.modal_raw_material.action}/${state.product.id}/${state.product.slq_company_id}`, state.raw_material)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            Notification.success({
                title: 'Muy bien',
                message: response.data.message,
                type: 'success',
                duration: 2000
            });
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Actualizar materia prima.
 */
export async function updateRawMaterial({state, commit, dispatch}, raw_material) {

    commit('dashboard/load', true, {root: true});

    await $http_cal.put(`raw-material/${raw_material.id}/${state.product.slq_company_id}`, raw_material)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            commit('setRawMaterial', response.data.data);
            commit('setStepToModalWizard', (state.modal_wizard.step + 1));

            Notification.success({
                title: 'Muy bien',
                message: response.data.message,
                type: 'success',
                duration: 2000
            });
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Eliminar materia prima.
 */
export async function deleteRawMaterial({state, commit, dispatch}, raw_material) {
    await Swal.fire({
        title: 'Eliminar',
        text: 'Esta seguro de eliminar la materia prima del producto?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Si',
    }).then(async (result) => {
        if (result.value) {
            await $http_cal.delete(`raw-material/${raw_material.id}/${state.product.slq_company_id}`)
                .then(async (response) => {
                    commit('dashboard/load', false, {root: true});

                    Notification.success({
                        title: 'Muy bien',
                        message: response.data.message,
                        type: 'success',
                        duration: 2000
                    });
                })
                .catch((error) => {
                    console.log(error);
                    commit('dashboard/load', false, {root: true});
                });
        }
    });
}

/**
 * Eliminar materia prima.
 */
export async function deleteProduct({state, commit, dispatch}, product) {
    await Swal.fire({
        title: 'Eliminar',
        text: 'Esta seguro de eliminar el producto seleccionado?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Si',
    }).then(async (result) => {
        if (result.value) {
            await $http_cal.delete(`products-calculator/${product.id}/${product.slq_company_id}`)
                .then(async (response) => {
                    commit('setModalShow', false);
                    commit('dashboard/load', false, {root: true});

                    await dispatch('getProducts', true);

                    await Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Muy bien!',
                        text: response.data.message,
                        timer: 2000
                    });

                })
                .catch((error) => {
                    console.log(error);
                    commit('dashboard/load', false, {root: true});
                });
        }
    });
}

/**
 * Obtener empresas
 */
export async function getCompanies({dispatch, commit, state}, name) {
    dispatch('getCompaniesRequest', name)
        .then(companies => commit('setCompanies', companies));
}

/**
 * Obtener empresas filtro
 */
export async function getCompaniesFilters({commit, dispatch}, name) {
    dispatch('getCompaniesRequest', name)
        .then(companies => commit('setCompaniesFilters', companies));
}

/**
 * Obtener empresas desde el back
 */
export async function getCompaniesRequest({commit, state, rootState}, name) {

    return await new Promise(async (resolve, reject) => {
        if (name && name.length >= 3 && !rootState.dashboard.loading) {

            let parameters = {
                params: {
                    nombre: name
                }
            };

            commit('dashboard/load', true, {root: true});

            await $http.get('/empresas/lista', parameters)
                .then((response) => {
                    commit('dashboard/load', false, {root: true});
                    resolve(response.data.data);
                })
                .catch(() => {
                    commit('dashboard/load', false, {root: true});
                    console.warn('No se encontraron empresas con el nombre especificado');
                    reject([]);
                });
        }
    });
}

/**
 * Obtener categorías.
 */
export async function getCategories({state, commit}) {

    commit('dashboard/load', true, {root: true});

    await $http_cal.post(`adm_productos/sga`)
        .then((response) => {
            commit('setCategories', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener componentes.
 */
export async function getComponents({state, commit, rootState}, filter) {
    if (rootState.dashboard.loading) return;

    commit('dashboard/load', true, {root: true});

    if (filter.length < 3) {
        commit('setComponents', []);
        commit('dashboard/load', false, {root: true});

        Notification.warning({
            title: 'Búsqueda',
            message: 'Digite un criterio de búsqueda',
            type: 'success',
            duration: 3000
        });

        return;
    }

    await $http_cal.get(`components-calculator/${state.product.slq_company_id}`, {params: {filter}})
        .then((response) => {
            commit('setComponents', response.data.data);
            commit('dashboard/load', false, {root: true});

            if (!state.components.length) {
                Notification.warning({
                    title: 'Búsqueda',
                    message: 'No se encontraron componente con el criterio de búsqueda',
                    type: 'success',
                    duration: 3000
                });
            }
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Crear componente.
 */
export async function createComponent({state, commit}) {

    commit('dashboard/load', true, {root: true});
    commit('setCompanyIdToNewComponent');

    return new Promise(async (resolve, reject) => {
        await $http_cal.post(`components-calculator/${state.product.slq_company_id}`, state.new_component)
            .then(async (response) => {
                commit('resetNewComponent');
                commit('dashboard/load', false, {root: true});

                Notification.success({
                    title: 'Muy bien',
                    message: response.data.message,
                    type: 'success',
                    duration: 2000
                });

                resolve(response.data.data);
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});

                let errorMessage = error.message || 'Ocurrió un error inesperado.';
                if (error.errors) {
                    errorMessage = Object.values(error.errors)
                        .reduce((acc, curr) => acc.concat(curr), [])
                        .join('<br>');
                }

                Notification.error({
                    title: 'Error',
                    message: errorMessage,
                    type: 'error',
                    duration: 4000
                });

                reject();
            });
    });
}

/**
 * Actualizar componente.
 */
export async function updateComponent({state, commit}) {

    commit('dashboard/load', true, {root: true});
    commit('setCompanyIdNewComponent');

    return new Promise(async (resolve, reject) => {
        await $http_cal.put(`components-calculator/${state.new_component.id}/${state.product.slq_company_id}`, state.new_component)
            .then(async (response) => {
                commit('resetNewComponent');
                commit('dashboard/load', false, {root: true});

                Notification.success({
                    title: 'Muy bien',
                    message: response.data.message,
                    type: 'success',
                    duration: 2000
                });

                resolve(response.data.data);
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});

                let errorMessage = error.message || 'Ocurrió un error inesperado.';
                if (error.errors) {
                    errorMessage = Object.values(error.errors)
                        .reduce((acc, curr) => acc.concat(curr), [])
                        .join('<br>');
                }

                Notification.error({
                    title: 'Error',
                    message: errorMessage,
                    type: 'error',
                    duration: 4000
                });

                reject();
            });
    });
}

export async function findComponent({state, commit}, cas_code) {
    commit('dashboard/load', true, {root: true});

    return new Promise(async (resolve, reject) => {
        await $http_cal.get(`product-component/${cas_code}`)
            .then(async (response) => {
                commit('dashboard/load', false, {root: true});
                resolve(response.data.data);
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});

                Notification.error({
                    title: 'Error',
                    message: error.message,
                    type: 'success',
                    duration: 4000
                });

                reject();
            });
    });
}

/**
 * Actualizar componentes.
 */
export async function updateComponents({state, commit}) {
    commit('dashboard/load', true, {root: true});

    return new Promise(async (resolve, reject) => {
        await $http_cal.post(`products-calculator/components/${state.raw_material.id}/${state.product.slq_company_id}`, state.raw_material.components)
            .then(async (response) => {
                commit('dashboard/load', false, {root: true});

                Notification.success({
                    title: 'Muy bien',
                    message: response.data.message,
                    type: 'success',
                    duration: 2000
                });

                resolve(response.data.data);
            })
            .catch((error) => {
                reject();
                console.log(error);
                commit('dashboard/load', false, {root: true});
            });
    });
}

/**
 * Crear componente de producto.
 */
export async function createComponentProduct({state, commit}, component_product) {
    commit('dashboard/load', true, {root: true});

    return new Promise(async (resolve, reject) => {
        await $http_cal.post(`component-product/${state.product.id}/${state.product.slq_company_id}`, component_product)
            .then(async (response) => {
                commit('dashboard/load', false, {root: true});

                Notification.success({
                    title: 'Muy bien',
                    message: response.data.message,
                    type: 'success',
                    duration: 2000
                });

                resolve(response.data.data);
            })
            .catch((error) => {
                reject();
                console.log(error);
                commit('dashboard/load', false, {root: true});
            });
    });
}

/**
 * Actualizar componente de producto.
 */
export async function updateComponentProduct({state, commit}, component_product) {
    commit('dashboard/load', true, {root: true});

    return new Promise(async (resolve, reject) => {
        await $http_cal.put(`component-product/${component_product.id}/${state.product.id}/${state.product.slq_company_id}`, component_product)
            .then(async (response) => {
                commit('dashboard/load', false, {root: true});

                Notification.success({
                    title: 'Muy bien',
                    message: response.data.message,
                    type: 'success',
                    duration: 2000
                });

                resolve(response.data.data);
            })
            .catch((error) => {
                reject();
                console.log(error);
                commit('dashboard/load', false, {root: true});
            });
    });
}

/**
 * Eliminar componente de producto.
 */
export async function deleteComponentProduct({state, commit}, component_product) {
    commit('dashboard/load', true, {root: true});

    return new Promise(async (resolve, reject) => {
        await $http_cal.delete(`component-product/${component_product.id}/${state.product.slq_company_id}`)
            .then(async (response) => {
                commit('dashboard/load', false, {root: true});

                Notification.success({
                    title: 'Muy bien',
                    message: response.data.message,
                    type: 'success',
                    duration: 2000
                });

                resolve(response.data.data);
            })
            .catch((error) => {
                reject();
                console.log(error);
                commit('dashboard/load', false, {root: true});
            });
    });
}

/**
 * Obtener unidades de medida.
 */
export async function getMeasureUnitsCl50({state, commit}) {
    commit('dashboard/load', true, {root: true});

    await $http_cal.get('lists/UMCAL')
        .then((response) => {
            commit('setMeasureUnitsCl50', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Actualizar DL y CL de un component.
 */
export async function updateComponentDlCl({state, commit, dispatch}) {
    commit('dashboard/load', true, {root: true});

    return new Promise(async (resolve, reject) => {
        await $http_cal.put(`components-calculator/dl-cl/${state.component_dl_cl.id}/${state.product.slq_company_id}`, state.component_dl_cl.dl_cl)
            .then(async (response) => {
                await dispatch('getGroupedComponents');
                commit('resetNewComponent');
                commit('dashboard/load', false, {root: true});

                Notification.success({
                    title: 'Muy bien',
                    message: response.data.message,
                    type: 'success',
                    duration: 2000
                });

                resolve(response.data.data);
            })
            .catch((error) => {
                reject();
                console.log(error);
                commit('dashboard/load', false, {root: true});
            });
    });
}

/**
 * Actualizar DL y CL de un product.
 */
export async function updateProductDlCl({state, commit}) {
    commit('dashboard/load', true, {root: true});

    return new Promise(async (resolve, reject) => {
        await $http_cal.put(`product-calculator/dl-cl/${state.product.id}/${state.product.slq_company_id}`, state.product.dl_cl)
            .then(async (response) => {
                commit('dashboard/load', false, {root: true});

                Notification.success({
                    title: 'Muy bien',
                    message: response.data.message,
                    type: 'success',
                    duration: 2000
                });

                resolve(response.data.data);
            })
            .catch((error) => {
                reject();
                console.log(error);
                commit('dashboard/load', false, {root: true});
            });
    });
}

/**
 * Obtener preguntas.
 */
export async function getQuestionGroups({state, commit}, code_question_group) {

    commit('dashboard/load', true, {root: true});
    await $http_cal.get('preguntas/' + code_question_group)
        .then((response) => {
            commit('setQuestionGroups', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener respuestas.
 */
export async function getAnswers({state, commit}) {
    commit('dashboard/load', true, {root: true});

    await $http_cal.get('respuestas-preguntas/' + state.product.id + '/' + state.product.slq_company_id)
        .then((response) => {
            commit('setAnswers', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Guardar respuestas.
 */
export async function saveAnswers({state, commit}, question_index) {
    commit('dashboard/load', true, {root: true});
    commit('clearAnswers', question_index);

    const data = {
        question_groups: state.question_groups,
        product_id: state.product.id,
        slq_company_id: state.product.slq_company_id,
        module_code: state.module_code,
        code_question_group: state.code_question_group,
        question_index: question_index
    };

    await $http_cal.post(`respuestas-preguntas`, data)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            commit('setClassification', response.data.data);
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener respuestas.
 */
export async function findComponentsByCASNumbers({state, commit}) {
    commit('dashboard/load', true, {root: true});

    let cas_numbers = [];

    state.product.raw_materials.map(rm => {
        rm.raw_material.components_product.map(c => {
            let index = cas_numbers.findIndex(co => co === c.component.code_cas);

            if (index < 0) {
                cas_numbers.push(c.component.code_cas);
            }
        });
    });

    let params = {
        cas_numbers
    };

    await $http.get('cas/listar-componentes-por-cas', {params})
        .then((response) => {
            commit('setComponentsIarc', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Guardar propiedades del producto.
 */
export async function saveProperties({state, commit}) {

    commit('dashboard/load', true, {root: true});

    return new Promise(async (resolve, reject) => {
        await $http_cal.post(`product-properties/${state.product.id}/${state.product.slq_company_id}`, state.product.properties)
            .then(async (response) => {
                commit('dashboard/load', false, {root: true});

                Notification.success({
                    title: 'Muy bien',
                    message: response.data.message,
                    type: 'success',
                    duration: 2000
                });

                resolve(response.data.data);
            })
            .catch((error) => {
                reject();
                console.log(error);
                commit('dashboard/load', false, {root: true});
            });
    });
}

/**
 * Guardar clasificación.
 */
export async function saveClassification({state, commit}, data) {
    commit('dashboard/load', true, {root: true});

    await $http_cal.put(`product-classification/${data.id}/${state.product.slq_company_id}`, data)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});

            let classification = response.data.data;

            classification.classified = 1;
            commit('setClassification', classification);
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Guardar clasificación.
 */
export async function getClassification({state, commit}, params) {
    commit('dashboard/load', true, {root: true});

    commit('resetClassification');

    return new Promise(async (resolve, reject) => {
        await $http_cal.get(`product-classification/${state.product.slq_company_id}`, {params})
            .then(async (response) => {
                commit('dashboard/load', false, {root: true});

                let classification = response.data.data;

                if (!!response.data.data) {
                    commit('setClassification', classification);
                    commit('setQuestionsIndexFromClassification');
                } else {
                    commit('resetClassification');
                }

                resolve(state.classification);
            })
            .catch((error) => {
                console.log(error);
                commit('dashboard/load', false, {root: true});
                reject();
            });
    });
}

/**
 * Obtener clases de peligro.
 */
export async function getDangerClasses({state, commit}) {
    commit('dashboard/load', true, {root: true});

    await $http_cal.get('lists/CLPE')
        .then((response) => {
            commit('setDangerClasses', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener módulos.
 */
export async function getModules({state, commit}) {
    commit('dashboard/load', true, {root: true});

    await $http_cal.get('lists/MCAL')
        .then((response) => {
            commit('setModules', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Request tipo GET para obtener grouped_components.
 * @author Jhon García
 */
export async function getGroupedComponents({commit, state}) {
    commit('dashboard/load', true, {root: true});
    await $http_cal
        .get(`grouped-components/${state.product.id}/${state.product.slq_company_id}`)
        .then(response => {
            commit('setGroupedComponents', response.data.data.grouped_components);
            commit('setTotals', response.data.data.totals);
            commit('dashboard/load', false, {root: true});
        })
        .catch(error => {
            console.error(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Solicitud para obtener las clasificaciones asociadas a un producto.
 *
 * @param {Object} context Contexto de Vuex, contiene funciones de state y commit.
 * @param {Object} payload Datos necesarios para la solicitud.
 * @param {string} payload.product_id El ID del producto.
 * @param {string} payload.company_id El ID de la empresa.
 * @returns {Promise<void>} Promesa que se resuelve una vez que se completó la solicitud.
 *
 * @author Jhon García
 */
export async function getProductClassifications({state, commit}, {product_id, company_id}) {

    commit('dashboard/load', true, {root: true});

    await $http_cal.get(`products-calculator-classifications/${product_id}/${company_id}`)
        .then((response) => {
            commit('setProductClassifications', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Solicitud para descargar la justificación de la clasificación.
 *
 * @param {Object} context Contexto de Vuex, contiene funciones de state y commit.
 * @returns {Promise<void>} Promesa que se resuelve una vez que se completó la solicitud.
 *
 * @author Jhon García
 */
export async function downloadClassification({commit, state}) {

    const file_name = 'JUSTIFICACIÓN ' + state.product.name.toUpperCase() + ' ' + state.product.company.nombre.toUpperCase() + '.pdf';

    commit('dashboard/load', true, {root: true});
    await $http_cal({
        url: `product-classification-pdf/${state.product.id}/${state.product.slq_company_id}`,
        method: 'POST',
        responseType: 'blob',
    }).then((response) => {
        commit('dashboard/load', false, {root: true});
        window.downloadFile(response.data, file_name);
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'No se encontró el archivo',
            showConfirmButton: true,
            timer: 5000
        });
    });
}


/**
 * Solicitud para descargar la composición del producto.
 *
 * @param {Object} context Contexto de Vuex, contiene funciones de state y commit.
 * @returns {Promise<void>} Promesa que se resuelve una vez que se completó la solicitud.
 *
 * @author Jhon García
 */
export async function downloadComposition({commit, state}) {

    const file_name = 'COMPOSICIÓN ' + state.product.name.toUpperCase() + ' ' + state.product.company.nombre.toUpperCase() + '.pdf';

    commit('dashboard/load', true, {root: true});
    await $http_cal({
        url: `product-composition-pdf/${state.product.id}/${state.product.slq_company_id}`,
        method: 'POST',
        responseType: 'blob',
    }).then((response) => {
        commit('dashboard/load', false, {root: true});
        window.downloadFile(response.data, file_name);
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'No se encontró el archivo',
            showConfirmButton: true,
            timer: 5000
        });
    });
}


/**
 * Solicitud para descargar la clasificación del peligro de toxicidad aguda.
 *
 * @param {Object} context Contexto de Vuex, contiene funciones de state y commit.
 * @returns {Promise<void>} Promesa que se resuelve una vez que se completó la solicitud.
 *
 * @author Jhon García
 */
export async function downloadClassificationAcuteToxicity({commit, state}) {

    const file_name = 'TOXICIDAD AGUDA ' + state.product.name.toUpperCase() + ' ' + state.product.company.nombre.toUpperCase() + '.pdf';

    commit('dashboard/load', true, {root: true});
    await $http_cal({
        url: `product-acute-toxicity-pdf/${state.product.id}/${state.product.slq_company_id}`,
        method: 'POST',
        responseType: 'blob',
    }).then((response) => {
        commit('dashboard/load', false, {root: true});
        window.downloadFile(response.data, file_name);
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'No se encontró el archivo',
            showConfirmButton: true,
            timer: 5000
        });
    });
}

/**
 * Solicitud para descargar la clasificación del peligro para el medio ambiente acuático - corto plazo.
 *
 * @param {Object} context Contexto de Vuex, contiene funciones de state y commit.
 * @returns {Promise<void>} Promesa que se resuelve una vez que se completó la solicitud.
 *
 * @author Jhon García
 */
export async function downloadClassificationShortTermAquaticEnvironment({commit, state}) {

    const file_name = 'PELIGRO PARA EL MEDIO AMBIENTE ACUÁTICO - CORTO PLAZO ' + state.product.name.toUpperCase() + ' ' + state.product.company.nombre.toUpperCase() + '.pdf';

    commit('dashboard/load', true, {root: true});
    await $http_cal({
        url: `product-short-term->aquatic-environment-pdf/${state.product.id}/${state.product.slq_company_id}`,
        method: 'POST',
        responseType: 'blob',
    }).then((response) => {
        commit('dashboard/load', false, {root: true});
        window.downloadFile(response.data, file_name);
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'No se encontró el archivo',
            showConfirmButton: true,
            timer: 5000
        });
    });
}

/**
 * Solicitud para descargar la clasificación del peligro para el medio ambiente acuático - largo plazo.
 *
 * @param {Object} context Contexto de Vuex, contiene funciones de state y commit.
 * @returns {Promise<void>} Promesa que se resuelve una vez que se completó la solicitud.
 *
 * @author Jhon García
 */
export async function downloadClassificationLongTermAquaticEnvironment({commit, state}) {

    const file_name = 'PELIGRO PARA EL MEDIO AMBIENTE ACUÁTICO - LARGO PLAZO ' + state.product.name.toUpperCase() + ' ' + state.product.company.nombre.toUpperCase() + '.pdf';

    commit('dashboard/load', true, {root: true});
    await $http_cal({
        url: `product-long-term->aquatic-environment-pdf/${state.product.id}/${state.product.slq_company_id}`,
        method: 'POST',
        responseType: 'blob',
    }).then((response) => {
        commit('dashboard/load', false, {root: true});
        window.downloadFile(response.data, file_name);
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'No se encontró el archivo',
            showConfirmButton: true,
            timer: 5000
        });
    });
}

/**
 * Solicitud para obtener los archivos asociados a un producto.
 *
 * @param {Object} context Contexto de Vuex, contiene funciones de state y commit.
 * @param {Object} payload Datos necesarios para la solicitud.
 * @param {string} payload.product_id El ID del producto.
 * @param {string} payload.company_id El ID de la empresa.
 * @returns {Promise<void>} Promesa que se resuelve una vez que se completó la solicitud.
 *
 * @author Jhon García
 */
export async function getFiles({state, commit}, {product_id, company_id}) {

    commit('dashboard/load', true, {root: true});

    await $http_cal.get(`file-product-calculator/${product_id}/${company_id}`)
        .then((response) => {
            commit('setFiles', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Solicitud para subir un documento asociado a un producto.
 *
 * @param {Object} context Contexto de Vuex, contiene funciones de state y commit.
 * @param {string} company_id El ID de la empresa.
 * @returns {Promise<void>} Promesa que se resuelve una vez que se completó la solicitud.
 *
 * @author Jhon García
 */
export async function uploadFile({commit, state}, company_id) {
    let form_data = new FormData();

    for (let key in state.file) {
        if (key !== 'parent') {
            form_data.append(key, state.file[key]);
        }
    }

    commit('dashboard/load', true, {root: true});

    await $http_cal.post('/file-product-calculator/' + company_id, form_data)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            commit('setShowToModalFile', false);

            Notification.success({
                title: 'Muy bien',
                message: response.data.message,
                type: 'success',
                duration: 2000
            });
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});

            Notification.error({
                title: 'Error',
                message: error.message,
                type: 'error',
                duration: 5000,
                customClass: 'notification-box',
            });
        });
}

/**
 * Solicitud para crear una carpeta en el arbor de archivos de un producto.
 *
 * @param {Object} context Contexto de Vuex, contiene funciones de state y commit.
 * @param {string} company_id El ID de la empresa.
 * @returns {Promise<void>} Promesa que se resuelve una vez que se completó la solicitud.
 *
 * @author Jhon García
 * @param company_id
 */
export async function createFolder({state, commit}, company_id) {
    commit('dashboard/load', true, {root: true});

    await $http_cal.post('folder-product-calculator/' + company_id, state.folder)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            commit('setShowToModalName', false);

            Notification.success({
                title: 'Muy bien',
                message: response.data.message,
                type: 'success',
                duration: 2000
            });
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});

            Notification.error({
                title: 'Error',
                message: error.message,
                type: 'error',
                duration: 5000,
                customClass: 'notification-box',
            });
        });
}

/**
 * Solicitud para actualizar el nombre de un archivo o una carpeta.
 *
 * @param {Object} context Contexto de Vuex, contiene funciones de state y commit.
 * @param {string} company_id El ID de la empresa.
 * @returns {Promise<void>} Promesa que se resuelve una vez que se completó la solicitud.
 *
 * @author Jhon García
 * @param company_id
 */
export async function updateName({state, commit}, company_id) {
    commit('dashboard/load', true, {root: true});

    await $http_cal.put('file-product-calculator/' + state.folder.id + '/' + company_id, state.folder)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            commit('setShowToModalName', false);

            Notification.success({
                title: 'Muy bien',
                message: response.data.message,
                type: 'success',
                duration: 2000
            });
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});

            Notification.error({
                title: 'Error',
                message: error.message,
                type: 'error',
                duration: 5000,
                customClass: 'notification-box',
            });
        });
}

/**
 * Solicitud para eliminar un archivo o una carpeta.
 *
 * @param {Object} context Contexto de Vuex, contiene funciones de state y commit.
 * @param {string} company_id El ID de la empresa.
 * @returns {Promise<void>} Promesa que se resuelve una vez que se completó la solicitud.
 *
 * @author Jhon García
 * @param company_id
 */
export async function deleteFile({state, commit}, company_id) {
    commit('dashboard/load', true, {root: true});

    await $http_cal.delete('file-product-calculator/' + state.folder.id + '/' + company_id, state.folder)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});

            Notification.success({
                title: 'Muy bien',
                message: response.data.message,
                type: 'success',
                duration: 2000
            });
        })
        .catch((error) => {
            console.log(error);
            commit('dashboard/load', false, {root: true});

            Notification.error({
                title: 'Error',
                message: error.message,
                type: 'error',
                duration: 5000,
                customClass: 'notification-box',
            });
        });
}

/**
 * Solicitud para obtener los datos de un archivo por id.
 *
 * @param {Object} context Contexto de Vuex, contiene funciones de state y commit.
 * @param {Object} payload Datos necesarios para la solicitud.
 * @param {string} payload.file Datos del archivo.
 * @param {string} payload.company_id El ID de la empresa.
 * @returns {Promise<void>} Promesa que se resuelve una vez que se completó la solicitud.
 *
 * @author Jhon García
 */
export async function getFileById({state, commit, dispatch}, {file, company_id}) {
    return new Promise(async (resolve, reject) => {
        commit('dashboard/load', true, {root: true});

        await $http_cal.get('file-product-calculator/show/' + file.id + '/' + company_id)
            .then(async (response) => {
                commit('dashboard/load', false, {root: true});
                resolve(response.data.data);
            })
            .catch((error) => {
                console.log(error);
                commit('dashboard/load', false, {root: true});

                Notification.error({
                    title: 'Error',
                    message: error.message,
                    type: 'error',
                    duration: 5000,
                    customClass: 'notification-box',
                });

                reject(null);
            });
    });
}

/**
 * Solicitud para descargar la composición del producto.
 *
 * @param {Object} context Contexto de Vuex, contiene funciones de state y commit.
 * @param {Object} file Datos del archivo.
 * @returns {Promise<void>} Promesa que se resuelve una vez que se completó la solicitud.
 *
 * @author Jhon García
 */
export async function downloadFile({commit, state}, file) {

    try {
        let pos = file.temporary_url.indexOf('/v1');
        let url = file.temporary_url.substring(pos + 3);

        commit('dashboard/load', true, {root: true});
        await $http_cal({
            url: url,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            commit('dashboard/load', false, {root: true});
            window.downloadFile(response.data, file.original_name + '.' + file.extension);
        }).catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'No se encontró el archivo',
                showConfirmButton: true,
                timer: 5000
            });
        });
    } catch (e) {
        console.error('URL no válida:', e);
        return null;
    }
}

/**
 * Solicitud para crear un fabricante.
 *
 * @param {Object} context Contexto de Vuex, contiene funciones de state y commit.
 * @returns {Promise<void>} Promesa que se resuelve una vez que se completó la solicitud.
 *
 * @author Jhon García
 */
export async function createManufacturer({state, commit}) {
    commit('dashboard/load', true, {root: true});

    await $http.post('/fabricantes', state.manufacturer)
        .then((response) => {
            commit('setManufacturerToProduct', response.data.fabricante);
            commit('dashboard/load', false, {root: true});
            Notification.success({
                title: 'Muy bien',
                message: response.data.message,
                type: 'success',
                duration: 2000
            });
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

/**
 * Solicitud para listar los componentes del producto y que estén listados en el protocolo de Montreal.
 *
 * @param {Object} context Contexto de Vuex, contiene funciones de state y commit.
 * @param {Object} payload Datos necesarios para la solicitud.
 * @param {string} payload.product_id El ID del producto.
 * @param {string} payload.company_id El ID de la empresa.
 * @returns {Promise<void>} Promesa que se resuelve una vez que se completó la solicitud.
 *
 * @author Jhon García
 */
export async function getComponentsListedInMontrealProtocol({state, commit}, {product_id, company_id}) {
    commit('dashboard/load', true, {root: true});

    return new Promise(async (resolve, reject) => {
        await $http_cal.get(`components-montreal-protocol/${product_id}/${company_id}`)
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                resolve(response.data.data);
            })
            .catch((error) => {
                reject(error);
                commit('dashboard/load', false, {root: true});
            });
    });
}
